import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

export interface GetConfigurableRolesQueryArgs {
  entityType: string;
}

export interface RolesForSellerSummaryDto {
  roles: {
    id: string;
    name: string;
    description: string;
  }[];
  sellerName: string;
  sellerId: string;
}

export const getConfigurableRolesRequest = (
  payload: GetConfigurableRolesQueryArgs,
): ApiRequestDescriptor => ({
  url: `${APIConfiguration.authorization}roles/configurable/${payload.entityType}`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getConfigurableRolesQuery = async (
  payload: GetConfigurableRolesQueryArgs,
): Promise<BackResponse<RolesForSellerSummaryDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<RolesForSellerSummaryDto[]>>(
      getConfigurableRolesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
